import { PortfolioCategoryGrid } from './PortfolioCategory' 
import { get_portfolio_categories } from '../../services'
import '../common.css'  

export default function Portfolio({ props }) {

    const categories = get_portfolio_categories().data
    
    return (
        <div className="main-content">
            <h1>Portfolio</h1>
            <PortfolioCategoryGrid categories={categories}/>
        </div>
    )
}
